import { ExecutionLoads } from '../models/ExecutionLoads.model';
import { GetShipment } from '../models/home/GetShipment.model';
import i18n from '../../i18n';
import { isEntitled } from './common';
import { INVITED_USER_CREDENTIALS_DOESNT_MATCH, MANAGE_USER_REQUEST, MODULES, WARNING_TITLE } from './constants';
import { ToastMessage } from './ToastMessage';

/**
 * Get PushNotification details based on the props
*/
export const getNotificationDetails = (props: any, sethasUpdateLoads: any, hasUpdateLoads: any, push: any) => {
  if (
    props.deepLinkURI !== '' &&
    props.notificationData &&
    props.notificationData.deepLinkURI !== ''
  ) {
    // User ID And Carrier ID check for right user login.
    if (props.notificationData.userId !== (props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.upn)) {
      // Show Error/ ReLogin Message;
      props.showAlert({
        isShowAlert: true,
        alertMessage: INVITED_USER_CREDENTIALS_DOESNT_MATCH,
        alertTitle: WARNING_TITLE
      });
      cleanNotification(props, sethasUpdateLoads);
      return;
    }

    if (!props.isNetworkAvailable) {
      cleanNotification(props, sethasUpdateLoads);
      props.showNetworkAlert();
      return;
    }

    const isMyloadNotification = props.deepLinkURI.includes('MyLoad');

    if (isMyloadNotification) {
      myLoadNotificationFlow(props, hasUpdateLoads, push, sethasUpdateLoads);
    } else {
      manageUserNotificationFlow(props, sethasUpdateLoads, push);
    }
  }
}

/**
 * Clear notifiaction details from store
*/
export const cleanNotification = (props: any, sethasUpdateLoads: any) => {
  sethasUpdateLoads(false);
  props.clearDeepLinkURI();
};

/**
 * based on the notifiaction details it will call shipment and getShipment API.
*/
export const myLoadNotificationFlow = (props: any, hasUpdateLoads: any, push: any, sethasUpdateLoads: any) => {
  const isDriverAssignedLoad = props.deepLinkURI.includes('DriverAssigned');
  const isCarrierAssignedLoad = props.deepLinkURI.includes('CarrierAssigned');
  const isIntransitLoad = props.deepLinkURI.includes('shipmentUpdateScreen');

  const currentShipmentID = props.deepLinkURI.substring(
    props.deepLinkURI.lastIndexOf('/') + 1,
    props.deepLinkURI.length
  );

  const load: any = isDriverAssignedLoad
    ? props.driverAssignedLoads.find(
      (load: any) => load.shipmentId === currentShipmentID
    )
    : isCarrierAssignedLoad
      ? props.carrierAssignedLoads.find((load: any) => load.shipmentId === currentShipmentID)
      : isIntransitLoad
        ? props.inTransitLoads.find((load: any) => load.shipmentId === currentShipmentID)
        : null;

  if (load || hasUpdateLoads) {
    if (isIntransitLoad) props.shipmentForStartTrip(load);
    redirectionToDriverDetailPage(load, props, push, sethasUpdateLoads);
  } else if (
    props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId &&
    props.isNetworkAvailable &&
    !load
  ) {
    const _model: ExecutionLoads = new ExecutionLoads();
    const isDriver = !isEntitled('myLoad', 'carrierAssigned');

    _model.filter = {
      carrierAssigned: isCarrierAssignedLoad,
      driverAssigned: isDriverAssignedLoad,
      inTransit: isIntransitLoad
    };

    if (isDriver) {
      _model.driverId = getUserPrincipalName(props) ;
    }

    props.fetchDriverShipments(_model.getRequestPayload(), false, () => {
      let module = '';
      module = getModule(isCarrierAssignedLoad,module, isDriverAssignedLoad, isIntransitLoad);
      const getShipmentmodel: GetShipment = new GetShipment();
      getShipmentmodel.shipmentIds = currentShipmentID;
      props.buyLoadShipmentRequest({
        query: getShipmentmodel.getRequestShipmentPayload(),
        currentShipmentID,
        module,
        isPullToRefresh: false
      });
    });
  }
};

/**
 * based on the notifiaction details it will show transfer user flow.
*/
export const manageUserNotificationFlow = (props: any, sethasUpdateLoads: any, push: any) => {
  if (props.notificationData && props.notificationData.type) {
    if (props.notificationData.type === MANAGE_USER_REQUEST) {
      const {
        requestedCarrierId: carrierId,
        carrierName,
        roles = ''
      } = props.notificationData;
      const transfer = {
        isRequested: true,
        details: {
          carrierId,
          carrierName: carrierName || carrierId,
          roles
        }
      };
      props.transferRequest({ transfer });
      push(props.notificationData.deepLinkURI, {
        transfer
      });
      return true;
    }
    props.resetUsersLoaded();
  }
  push(props.deepLinkURI, { resetLoaded: true });
  cleanNotification(props, sethasUpdateLoads);
};

/**
 * navigate to respcetive loadDetails Page.
*/
export const redirectionToDriverDetailPage = (_load: any, props: any, push: any, sethasUpdateLoads: any) => {
  _load ? push(props.deepLinkURI) : ToastMessage.show(i18n.t('ISSUE_WITH_ASSIGNED_LOAD'), 2000);
  cleanNotification(props, sethasUpdateLoads);
};

function getUserPrincipalName(props: any): string {
  return props.userDetails && props.userDetails.memberDetailsResponse &&
  props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.upn || '';
}

function getModule(isCarrierAssignedLoad: any, module:string, isDriverAssignedLoad: any, isIntransitLoad: any) {
  module = '';
  if (isCarrierAssignedLoad) {
    module = MODULES.CARRIER_ASSIGNED_MODULE;
  } else if (isDriverAssignedLoad) {
    module = MODULES.DRIVER_ASSIGNED_MODULE;
  } else if (isIntransitLoad) {
    module = MODULES.INTRANSIT_MODULE;
  }
  return module;
}
